import { useQueryClient } from '@tanstack/react-query';
import lodash from 'lodash';
import GeneralFunctions from '../../store/general/functions';
import ArrayHelper from '../../services/helper/arrayHelper';

export const queryErrorHandler = (errorMessage : string) => {
    const handleError = (error : Error) => {
        GeneralFunctions.generalShowErrorSnackbarV2(
            errorMessage,
            error,
        );

    };
    
    return handleError;
};

export const querySuccessHandler = <T extends { id : number }>(getKey : string, successMessage : string) => {
    const queryClient = useQueryClient();

    const handleOnSuccess = (result : T | Array<T>) => {
        const isArrayType = Array.isArray(result);
        
        queryClient.setQueriesData([getKey], (cachedData ?: Array<T>) => {
            if (!cachedData) return [result];

            if (isArrayType) {
                return ArrayHelper.upsertElements(cachedData, [...result], (a : T, b : T) => a.id == b.id);
            } else {
                return ArrayHelper.upsertElement(cachedData, result, (x => x.id === result.id));
            }
        });

        GeneralFunctions.generalShowSuccessSnackbar(successMessage);
    };

    return handleOnSuccess;
};

export const queryDeleteSuccessHandler = <T extends { id : number; isActive : boolean }>(deleteKey : string, getKey : string, successMessage : string) => {
    const queryClient = useQueryClient();

    const handleOnSuccess = (data : void, deletedId : number) => {
        queryClient.setQueriesData([getKey], (cachedData ?: Array<T>) => {
            if (!cachedData) return [cachedData];

            const deletedData = lodash.cloneDeep(cachedData.find(x => x.id === deletedId));

            if (deletedData) {
                deletedData.isActive = false;
                return ArrayHelper.upsertElement(cachedData, deletedData, (x => x.id === deletedId));
            }
            
            return cachedData;
        });

        queryClient.invalidateQueries([deleteKey]);

        GeneralFunctions.generalShowSuccessSnackbar(successMessage);
    };

    return handleOnSuccess;
};

export const queryNoReturnContentSuccessHandler = (successMessage : string) => {
    const handleOnSuccess = () => {
        GeneralFunctions.generalShowSuccessSnackbar(successMessage);
    };

    return handleOnSuccess;
};
